'use client'

import { useState } from 'react'
import { ct } from '@/lib/i18n/configurator'

interface WishlistEmailPopupProps {
  onSubmit: (email: string) => void
  onClose: () => void
}

export function WishlistEmailPopup({ onSubmit, onClose }: WishlistEmailPopupProps) {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      setError(ct('emailInvalid'))
      return
    }

    onSubmit(email)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative animate-in fade-in zoom-in duration-200">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Heart icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-pink-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-gray-900 text-center mb-2">
          {ct('myWishlist')}
        </h2>

        {/* Description */}
        <p className="text-gray-600 text-center mb-6">
          {ct('emailIntro')}
          <br />
          <span className="text-pink-500 font-medium">{ct('emailHave')}</span> {ct('emailHaveText')}
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                setError('')
              }}
              placeholder={ct('emailPlaceholder')}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#171717] focus:border-[#171717] outline-none transition-colors text-gray-900"
              autoFocus
            />
            {error && (
              <p className="mt-2 text-sm text-red-500">{error}</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-[#171717] hover:bg-black text-white font-medium rounded-lg transition-colors"
          >
            {ct('continue')}
          </button>
        </form>
      </div>
    </div>
  )
}
